import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-enerverze-bg border-t border-enerverze-border pt-16 pb-8">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <Logo className="h-8 w-8" />
              <span className="text-sm font-semibold text-enerverze-text">(주)에너버즈</span>
            </div>
            <div className="space-y-2 text-sm text-enerverze-muted">
              <p>경기도 파주시 문발로 132</p>
              <p>ccc62000@daum.net</p>
              <p>개업연월일: 2023. 2. 15</p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-enerverze-subtle uppercase tracking-wider mb-6">
              Newsletter
            </h4>
            <div className="relative">
              <input
                type="email"
                placeholder="이메일을 입력하세요"
                className="w-full bg-transparent border-b border-enerverze-dim py-2 pr-8 text-sm text-enerverze-text placeholder-enerverze-subtle focus:outline-none focus:border-neon-cyan transition-colors"
              />
              <button className="absolute right-0 top-1/2 -translate-y-1/2 text-neon-cyan hover:text-neon-green transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
            <p className="text-xs text-enerverze-subtle mt-3">
              에너버즈의 최신 소식을 받아보세요.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-medium text-enerverze-subtle uppercase tracking-wider mb-6">
              Sitemap
            </h4>
            <div className="space-y-3">
              <a
                href="/#about"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                회사소개
              </a>
              <a
                href="/#technology"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                기술소개
              </a>
              <a
                href="/solutions"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                솔루션
              </a>
              <a
                href="/patents"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                특허
              </a>
              <a
                href="/ir"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                IR
              </a>
              <a
                href="/rnd"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                R&D
              </a>
              <a
                href="/#contact"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                문의
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-medium text-enerverze-subtle uppercase tracking-wider mb-6">
              Social
            </h4>
            <div className="space-y-3">
              <a
                href="#"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                LinkedIn
              </a>
              <a
                href="#"
                className="block text-sm text-enerverze-text hover:text-neon-cyan transition-colors"
              >
                YouTube
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-enerverze-border pt-8">
          <p className="text-6xl md:text-8xl lg:text-[10rem] font-bold text-enerverze-text/10 tracking-tight leading-none">
            ENERVERZE
          </p>
          <p className="text-xs text-enerverze-subtle mt-4 text-center">
            &copy; 2023-2026 (주)에너버즈. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}